import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { Colour } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ColourService extends TmsWebBaseEditService<Colour, Colour> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('Colour', $localize`Colour`, httpService, notificationService);
  }
}
